import config from '../util/config';

function useIsInGovCloudEnv(): boolean {
  return config.awsPartition === 'aws-us-gov';
}

export default useIsInGovCloudEnv;
